var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.34,
    height: 38.34,
    viewBox: "0 0 38.34 38.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e4e4e4",
    d: "M19.169 0A19.17 19.17 0 1 0 38.34 19.169 19.171 19.171 0 0 0 19.169 0zm3.991 29.71q-1.48.584-2.361.889a6.229 6.229 0 0 1-2.048.307 4.082 4.082 0 0 1-2.786-.875 2.823 2.823 0 0 1-.992-2.218 8.059 8.059 0 0 1 .073-1.069c.05-.364.13-.772.239-1.232l1.235-4.362c.109-.419.2-.816.278-1.186a5.26 5.26 0 0 0 .11-1.027 1.582 1.582 0 0 0-.344-1.164 1.954 1.954 0 0 0-1.319-.326 3.463 3.463 0 0 0-.982.146c-.333.1-.622.195-.858.286l.326-1.344q1.212-.494 2.321-.846a6.856 6.856 0 0 1 2.094-.354 4.006 4.006 0 0 1 2.746.86 2.858 2.858 0 0 1 .964 2.233q0 .285-.067 1a6.7 6.7 0 0 1-.247 1.316l-1.229 4.349c-.1.349-.19.748-.271 1.194a6.316 6.316 0 0 0-.118 1.016 1.459 1.459 0 0 0 .388 1.181 2.171 2.171 0 0 0 1.342.315 3.893 3.893 0 0 0 1.016-.157 5.776 5.776 0 0 0 .821-.276zm-.217-17.654a2.932 2.932 0 0 1-2.069.8 2.963 2.963 0 0 1-2.077-.8 2.549 2.549 0 0 1-.865-1.936 2.575 2.575 0 0 1 .868-1.941 2.941 2.941 0 0 1 2.077-.807 2.908 2.908 0 0 1 2.069.807 2.615 2.615 0 0 1 0 3.877z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationButton);
export default __webpack_public_path__ + "static/media/information-button.639857ac9f30be0505f9d1fc17cb8b51.svg";
export { ForwardRef as ReactComponent };